
import { Component, Mixins } from "vue-property-decorator";
import { Point } from "../../../../../../base/domain/drawing";
import { ILocationPropertyEditable, instanceOfILocationPropertyEditable } from "../../../../../domain/editableFormat/properties";

@Component
export default class LocationPropertyEditableMixin extends Mixins() {
  // ModelEditableMixinと同時に使う事.ModelEditableMixin利用APIの宣言.
  writePropertyWhenValid: (writer: (source: ILocationPropertyEditable) => void) => void;
  readPropertyOrDefault: <T>(reader: (source: ILocationPropertyEditable) => T, defaultValue: T) => T;

  // ドメイン層のエンティティは全てinterfaceにしてるが、
  // 本体のコンポーネントは従来のクラスエンティティで実装されてるのでそっちに合わせないと既存部品を再利用できない。
  // Vueの世界の話なのでコンポーネント側の実装で吸収する。

  get isLocationEditable(): boolean {
    return this.readPropertyOrDefault(s => instanceOfILocationPropertyEditable(s) && s.location().isEditable(), false);
  }

  get location(): Point {
    return this.readPropertyOrDefault(s => Point.from(s.location().getValue()), new Point(0, 0));
  }

  set location(value: Point) {
    this.writePropertyWhenValid(s => s.location().setValue(Point.to(value)));
  }
}
